import { DefaultLayout } from "~/layouts/DefaultLayout";
import { MetaHeader } from "~/components/MetaHeader";
import { useState } from "react";
import { questionArray, typeArray } from "~/constants";
import type { ActionFunction } from "remix";
import { useFetcher } from "remix";
import { SupabaseClientFn } from "~/utils/db.server";

export const action: ActionFunction = async ({ request }) => {
    const formData = await request.formData();
    const userAnswers = formData.get("userAnswers");
    const userAnswersArray = JSON.parse(userAnswers as string);
    const { data, error } = await SupabaseClientFn
        .from('mbti')
        .insert([
            {
                java: userAnswersArray[0],
                keny: userAnswersArray[1],
                yirg: userAnswersArray[2],
                blue: userAnswersArray[3],
                suma: userAnswersArray[4],
                kona: userAnswersArray[5],
                rob: userAnswersArray[6],
                harr: userAnswersArray[7],
                guat: userAnswersArray[8]
            }
        ]);

    if (!data) throw Error(error?.message);
    // 処理が完了したら、リダイレクトまたは必要なデータを返す
    return 'success';
};
const Cafe: React.VFC = () => {
    const [count, setCount] = useState(0);
    const [userAnswers, setUserAnswers] = useState(new Array(questionArray.length).fill(0));
    const fetcher = useFetcher();

    const saveAnswer = (answerIndex: number) => {
        const selectedAnswer = questionArray[count][`ans${answerIndex}`];
        const newUserAnswers = userAnswers.map((score, index) => score + selectedAnswer[index]);

        setUserAnswers(newUserAnswers);
        setCount(prevCount => prevCount + 1);

        if (count + 1 === 16) {
            setTimeout(() => {
                fetcher.submit({ userAnswers: JSON.stringify(newUserAnswers) }, { method: "post", action: "/diagnosis" });
            }, 0.5);
        }
    }
    function buttonText(index: number) {
        const texts = ["はい", "いいえ", "どちらかといえばはい", "どちらかと言えばいいえ"];
        return texts[index];
    }


    function findIndexOfMax(array: number[]) {
        if (array.length === 0) {
            return -1; // 配列が空の場合
        }

        let maxIndex = 0;
        let maxValue = array[0];
        for (let i = 1; i < array.length; i++) {
            if (array[i] > maxValue) {
                maxValue = array[i];
                maxIndex = i;
            }
        }

        return maxIndex;
    }

    // 画像を表示するコンポーネント
    const DisplayImage = (userAnswers: UserAnswersType) => {
        const maxIndex = findIndexOfMax(userAnswers.userAnswers);
        const type = typeArray[maxIndex];
        localStorage.setItem('type', JSON.stringify(type.img));
        return <img src={type.img} alt={type.title} />;
    };

    const twitterShare = () => {
        const route = window.location.href
        // シェアする画面を設定
        const type = JSON.parse(localStorage.getItem('type') as string);
        const imageUrl = type;
        var shareURL = 'https://twitter.com/intent/tweet?text=' + "カフェのMBTI診断を作成してみました" + "診断結果はこちら" + '&url=' + route + '&amp;media=' + imageUrl;
        // シェア用の画面へ移行
        location.href = shareURL;
    }
    return (
        <>
            <MetaHeader title={"福岡カフェ診断 - 福岡カフェ日記 | 福岡最大級のカフェメディア"} description={"「福岡カフェ診断テスト」では、あなたの性格タイプに基づいて福岡カフェをご紹介します。MBTI理論にインスパイアされたこの診断テストを通じて、あなたの好みや性格にぴったり合うカフェが見つかるかもしれません。福岡の隠れた名店から話題のカフェまで、あなたのための特別なカフェリストを提供します。診断結果に基づき、心地よいカフェタイムをお過ごしいただけること間違いなし！さあ、福岡カフェ診断テストであなたに最適なカフェスポットを見つけましょう。"} />

            <DefaultLayout>
                <fetcher.Form id="diagnosisForm" method="post" action="/diagnosis">
                    <input
                        type="hidden"
                        name="userAnswers"
                        id="userAnswersInput"
                    />
                    {count < 16 ? (
                        <>
                            <h1 className="recommend_title">カフェ診断テスト</h1>
                            <p className="recommend_num">QUESTION{count + 1}</p>
                            <p className="recommend_text">{questionArray[count][`question${count + 1}`]}</p>
                            <div className="recommend_btn_wrapper">
                                {[1, 2, 3, 4].map(i => (
                                    <div
                                        key={i}
                                        className="recommend_btn"
                                        onClick={() => saveAnswer(i)}
                                    >
                                        <span style={{ height: "10px", marginRight: "10px" }}>▶︎</span>
                                        {buttonText(i - 1)}
                                    </div>
                                ))}
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="recommend_img">
                                <DisplayImage userAnswers={userAnswers} />
                            </div>
                            <h3 className="shared_button" onClick={() => twitterShare()}>SNSで診断結果をシェアする</h3>
                        </>
                    )}
                </fetcher.Form>
            </DefaultLayout>
        </>
    );
};

export default Cafe;